import React from 'react';
import { cardSize } from '../../catalog';
import { V, T, Img } from '../primitives';
import { CardFaceProps, Validity, faceBase, faceData, type } from './shared';

/** The back: where to return a found card, the school's rules, the
 *  validity and the signature. Shared by every layout, in its orientation. */
const CardBack: React.FC<CardFaceProps> = (props) => {
  const { design, school, validUntil } = props;
  const { palette } = faceData(props);
  const { width, height } = cardSize(design.layout);
  const portrait = height > width;
  const watermark = Math.min(width, height) * 0.62;
  const { showSchoolContact, instructions, signatory } = design.back;

  return (
    <V style={faceBase(width, height, palette.paper)}>
      <V style={{ height: 7, backgroundColor: palette.primary }} />
      <V style={{ height: 1.4, backgroundColor: palette.accent }} />

      {(school.watermark ?? school.logo) && (
        <V style={{ position: 'absolute', left: (width - watermark) / 2, top: (height - watermark) / 2, width: watermark, height: watermark, opacity: 0.06 }}>
          <Img src={(school.watermark ?? school.logo)!} style={{ width: watermark, height: watermark, objectFit: 'contain' }} />
        </V>
      )}

      <V style={{ paddingHorizontal: 13, paddingTop: portrait ? 16 : 11 }}>
        {showSchoolContact && (
          <V style={{ marginBottom: portrait ? 12 : 8 }}>
            <T style={[type.label, { color: palette.inkFaint }]}>If found, please return to</T>
            <T style={{ fontSize: 7.2, fontWeight: 700, color: palette.ink, marginTop: 2.5 }} lines={2}>{school.name}</T>
            {school.address ? <T style={{ fontSize: 5.5, color: palette.inkMuted, marginTop: 1.5, lineHeight: 1.3 }} lines={2}>{school.address}</T> : null}
            {school.phone ? <T style={[type.mono, { fontSize: 5.6, fontWeight: 500, color: palette.primaryText, marginTop: 1.5 }]}>{school.phone}</T> : null}
          </V>
        )}
        {instructions.map((line, i) => (
          <V key={i} style={{ flexDirection: 'row', marginBottom: 2.6 }}>
            <T style={{ width: 8, fontSize: 5.2, fontWeight: 700, color: palette.primaryText }}>{i + 1}.</T>
            <T style={{ flex: 1, fontSize: 5.2, color: palette.inkMuted, lineHeight: 1.35 }} lines={portrait ? 4 : 2}>{line}</T>
          </V>
        ))}
      </V>

      {/* Validity and signature */}
      <V style={{ position: 'absolute', left: 13, right: 13, bottom: 11, flexDirection: 'row', alignItems: 'flex-end' }}>
        <V style={{ flex: 1 }}>
          <Validity validUntil={validUntil} color={palette.ink} labelColor={palette.inkFaint} />
        </V>
        <V style={{ width: portrait ? 62 : 74, alignItems: 'center' }}>
          <V style={{ alignSelf: 'stretch', height: 0.7, backgroundColor: palette.ink, opacity: 0.55, marginBottom: 2.5 }} />
          <T style={[type.label, { color: palette.inkMuted }]} lines={1}>{signatory || 'Authorised signatory'}</T>
        </V>
      </V>
    </V>
  );
};

export default CardBack;
